import React, { useCallback } from 'react';

export interface SortMenuProps {
    currentSortDescription: string;
    currentSortExpression: string;
    currentSortAscending: boolean;
    hideSort: boolean;
    showEmailSearchButton: boolean;
    sortExpressions: Array<{
        expression: string;
        description: string;
        isAscending: boolean;
    }>;
    onSortChange: (expression: string, isAscending: boolean) => void;
}

const SortMenu: React.FC<SortMenuProps> = ({
    currentSortDescription,
    currentSortExpression,
    currentSortAscending,
    hideSort,
    showEmailSearchButton,
    sortExpressions,
    onSortChange
}) => {
    const handleSortClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            const expression = e.currentTarget.getAttribute('data-sort-expression');
            const isAscendingAttr = e.currentTarget.getAttribute('data-sort-ascending');
            const isAscending = isAscendingAttr === 'true';

            if (expression) {
                onSortChange(expression, isAscending);
            }
        },
        [onSortChange]
    );

    if (hideSort) {
        return null;
    }

    //const sortMenuCss = showEmailSearchButton ? 'mar-r-2' : '';
    const sortButtonCss = !showEmailSearchButton ? '' : 'mar-r-2-md mar-r-2-lg';
    /* <div className={`position-relative ${sortMenuCss} flex-1-xs flex-1-sm`}> */
    return (
        <div className="position-relative flex-1">
            <button
                className={`dropdown-toggle btn btn-default btn-sm font-4 btn-block-xs btn-block-sm rounded-2 ${sortButtonCss}`}
                type="button"
                id="sortMenu"
                data-toggle="dropdown"
                aria-expanded="true"
                data-selected-sort-ascending={currentSortAscending}
                data-selected-sort-expression={currentSortExpression}
            >
                Sort By <span className="hidden-xs">{currentSortDescription}</span> <span className="caret"></span>
            </button>
            <ul className="dropdown-menu pull-right" role="menu" aria-labelledby="sortMenu">
                {sortExpressions.map(sortOption => {
                    const isSelected =
                        currentSortExpression === sortOption.expression &&
                        currentSortAscending === sortOption.isAscending;

                    return (
                        <li key={`${sortOption.expression}-${sortOption.isAscending}`} role="presentation">
                            <a
                                role="menuitem"
                                tabIndex={-1}
                                href="#"
                                data-sort-ascending={sortOption.isAscending}
                                data-sort-expression={sortOption.expression}
                                onClick={handleSortClick}
                            >
                                {sortOption.description}
                                {isSelected ? (
                                    <>
                                        &nbsp;<i className="fa fa-check"></i>
                                    </>
                                ) : null}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default SortMenu;
